module.exports = __webpack_public_path__ + "img/bg_row_1ez.ffd02ce3.svg";